import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../../shared/context/AdminContext';
import { LoadingSpinner } from './Spinner/Spinner';
import { portfolioApi } from '../../shared/services/portfolioApi';
import * as primitives from '../../../styles/system/primitives.css';

export interface AdminOnlyRouteProps {
  children: React.ReactNode;
}

const AdminOnlyRoute: React.FC<AdminOnlyRouteProps> = ({ children }) => {
  const { isAuthenticated, isAdmin, isLoading } = useAdmin();
  const location = useLocation();
  const [verifying, setVerifying] = useState(false);
  const [serverIsAdmin, setServerIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      if (isAuthenticated && !isLoading) {
        setVerifying(true);
        const result = await portfolioApi.checkAdminPermissions();
        if (mounted) {
          setServerIsAdmin(result.isAdmin);
          setVerifying(false);
        }
      }
    };
    verify();
    return () => {
      mounted = false;
    };
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return (
      <div className={primitives.screenCenter}>
        <LoadingSpinner size="large" />
        <p>Vérification des autorisations...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (!isAdmin || (serverIsAdmin === false && !verifying)) {
    return <Navigate to="/403" replace />;
  }

  // Attendre la vérification serveur si nécessaire
  if (verifying) {
    return (
      <div className={primitives.screenCenter}>
        <LoadingSpinner size="large" />
        <p>Vérification des autorisations serveur...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminOnlyRoute;
